<template>
     <v-expansion-panel focusable  popout  @click.once="getAuthorPublications" >
        <v-expansion-panel-header  :class="{xsclass:xsOnly, lgclass:!xsOnly}" >
            {{ $t("production.publications")}}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mx-0">
            <app-select-year-type :key="componentKey" :typeProduction="typeProduction" :showType="showType" :id="id"></app-select-year-type>
            <app-publications-list :typeProduction="typeProduction" ></app-publications-list>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
import publicationsList from '../../research/publications/PublicationsList.vue';
import selectYearType from '../../research/SelectYearType.vue';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';

export default {
    props:['id'],
    data(){
        return{
            typeProduction:'publications',
            showType:true,
            criterias:{
                selectedYear: 1,
                selectedDepartment: 0,
                selectedMember: this.id,
                selectedGrant: 0,
                selectedInvestigator: 0,
                selectedType: 20,
                idDepartmentGrants:0,
            },
            componentKey:0,
        }
    },
    components:{
        'appSelectYearType':selectYearType,
        'appPublicationsList': publicationsList,
    },   
    computed:{
        ...mapGetters('header',{
            xsOnly:'xsOnly'
        }),
        ...mapGetters('publication', {
            publications:'publications',
        }),
    },
    methods: {
        getAuthorPublications(){
            this.setPublications(this.criterias);
        },
        ...mapActions('publication',{
            setPublications:'setPublications',
        }),
    },
}
</script>
<style scoped>

.xsclass{
    width: 100%;
}
.lgclass{
    width: 8%;
}
</style>
